
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { fetchAllHyperdriveNotificationsCountsDataAPI, fetchHyperdriveNotificationCountAPI, fetchHyperdriveReadAllNotificationAPI, fetchHyperdriveReadSingleNotificationAPI, fetchNotificationCountAPI, fetchNotificationCountDataAPI, fetchReadAllNotificationAPI, fetchReadSingleNotificationAPI } from "../../redux/apis/notifications"

const initialState = {
    addProductNotifications: [],
    addHyperdriveNotifications:[],
    notificationCount: 0,
    loading: false,
    notifications: {}
}

export const fetchAllNotificationsCountsData = createAsyncThunk(
    'approvals/fetchNotificationCounts',
    async (notificationType = '', { rejectWithValue }) => {
        try {
            const res = await fetchNotificationCountDataAPI(notificationType)
            return res
        } catch (error) {

            return rejectWithValue(error?.response?.data)
        }
    }
)


export const fetchNotificationCount = createAsyncThunk(
    'approvals/fetchNotificationCount',
    async (notificationType = '', { rejectWithValue }) => {
        try {
            const res = await fetchNotificationCountAPI(notificationType)
            return res
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

export const fetchReadSingleNotification = createAsyncThunk(
    'approvals/fetchReadSingleNotification',
    async (filters, { rejectWithValue }) => {
        try {
            const res = await fetchReadSingleNotificationAPI(filters)
            return res
        } catch (error) {
            return rejectWithValue(error?.response.data)
        }
    }
)

export const fetchReadAllNotifications = createAsyncThunk(
    'approvals/fetchReadAllNotifications',
    async (notificationType = '', { rejectWithValue }) => {
        try {
            const res = await fetchReadAllNotificationAPI(notificationType)
            return res
        } catch (error) {

            return rejectWithValue(error?.response?.data)
        }
    }
)

// hyperdrive
export const fetchAllHyperdriveNotificationsCountsData = createAsyncThunk(
    'approvals/fetchAllHyperdriveNotificationsCountsData',
    async (notificationType = '', { rejectWithValue }) => {
        try {
            const res = await fetchAllHyperdriveNotificationsCountsDataAPI(notificationType)
            return res
        } catch (error) {

            return rejectWithValue(error?.response?.data)
        }
    }
)
export const fetchHyperdriveReadSingleNotification = createAsyncThunk(
    'approvals/fetchHyperdriveReadSingleNotification',
    async (filters, { rejectWithValue }) => {
        try {
            const res = await fetchHyperdriveReadSingleNotificationAPI(filters)
            return res
        } catch (error) {
            return rejectWithValue(error?.response.data)
        }
    }
)

export const fetchHyperdriveReadAllNotifications = createAsyncThunk(
    'approvals/fetchHyperdriveReadAllNotifications',
    async (notificationType = '', { rejectWithValue }) => {
        try {
            const res = await fetchHyperdriveReadAllNotificationAPI(notificationType)
            return res
        } catch (error) {

            return rejectWithValue(error?.response?.data)
        }
    }
)

export const fetchHyperdriveNotificationCount = createAsyncThunk(
    'approvals/fetchHyperdriveNotificationCount',
    async (notificationType = '', { rejectWithValue }) => {
        try {
            const res = await fetchHyperdriveNotificationCountAPI(notificationType)
            return res
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const notificationSlice = createSlice({
    name: 'products',
    initialState,
    reducers: {
        storeAddProductNotifications(state, action) {
            state.addProductNotifications = [...state.addProductNotifications, action.payload]
            localStorage.setItem('addProductNotifications', JSON.stringify([...state.addProductNotifications, action.payload]))
        },
        setNewAddProductNotifications(state, action) {
            state.addProductNotifications = action.payload
            localStorage.setItem('addProductNotifications', JSON.stringify(action.payload))
        },

        AddHyperdriveNotifications(state, action) {
            state.addHyperdriveNotifications = [...state.addHyperdriveNotifications, action.payload]
            localStorage.setItem('addHyperdriveNotifications', JSON.stringify([...state.addHyperdriveNotifications, action.payload]))
        },
        RemoveHyperdriveNotification(state, action) {
            const updated = state.addHyperdriveNotifications.filter(
              (n, i) => i !== action.payload // index-based remove
            )
            state.addHyperdriveNotifications = updated
            localStorage.setItem('addHyperdriveNotifications', JSON.stringify(updated))
          },
          
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllNotificationsCountsData.pending, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllNotificationsCountsData.fulfilled, (state, action) => {
                state.loading = false;
                state.notificationCount = action.payload?.count
                state.addProductNotifications = action.payload?.data
            })
            .addCase(fetchAllNotificationsCountsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        builder
            .addCase(fetchReadAllNotifications.pending, (state, action) => {
                state.loading = false;
                state.notifications = action.payload;
            })
            .addCase(fetchReadAllNotifications.fulfilled, (state, action) => {
                state.loading = false;
                state.notifications = action.payload
                // You can update your state with the data received from the API if needed
            })
            .addCase(fetchReadAllNotifications.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // The error message returned from the API
            });

        builder
            .addCase(fetchNotificationCount.fulfilled, (state, action) => {
                state.notificationCount = action.payload.count;
            })
            .addCase(fetchNotificationCount.rejected, (state, action) => {
                state.error = action.payload
            })

        builder
            .addCase(fetchAllHyperdriveNotificationsCountsData.pending, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllHyperdriveNotificationsCountsData.fulfilled, (state, action) => {
                state.loading = false;
                // state.notificationCount = action.payload?.count
                // state.addProductNotifications = action.payload?.data
            })
            .addCase(fetchAllHyperdriveNotificationsCountsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

             builder
            .addCase(fetchHyperdriveReadAllNotifications.pending, (state, action) => {
                state.loading = false;
                state.notifications = action.payload;
            })
            .addCase(fetchHyperdriveReadAllNotifications.fulfilled, (state, action) => {
                state.loading = false;
                state.notifications = action.payload
                // You can update your state with the data received from the API if needed
            })
            .addCase(fetchHyperdriveReadAllNotifications.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // The error message returned from the API
            });

            builder
            .addCase(fetchHyperdriveNotificationCount.fulfilled, (state, action) => {
                state.notificationCount = action.payload.total;
            })
            .addCase(fetchHyperdriveNotificationCount.rejected, (state, action) => {
                state.error = action.payload
            })

    },
});

export const {
    storeAddProductNotifications,
    AddHyperdriveNotifications,
    setNewAddProductNotifications,
    RemoveHyperdriveNotification
} = notificationSlice.actions

export default notificationSlice.reducer;